import PortalIdParser from 'PortalIdParser';
const getBaseUrl = () => '/settings';
export const getRootUrl = () => `${getBaseUrl()}/${PortalIdParser.get()}`;
export const getPaymentsURL = () => `${getRootUrl()}/sales/payments`;
export const PaymentLinksURL = `/payment-links/${PortalIdParser.get()}`;